import { FiltersLayout } from 'shared/components/FiltersLayout';
import { useAvailableFilters } from 'shared/hooks';
import { ApplyFiltersButtonContainer } from '../ApplyFiltersButton';
import { TagsContainer } from '../TagsContainer';
import { FC } from 'react';
import { SaveSearchButtonContainer } from '../SaveSearchButtonContainer';
import { FILTERS_SET, FILTERS_MAP } from './constants';

export const FiltersContainer: FC = () => {
  const filters = useAvailableFilters({ filtersSet: FILTERS_SET, filtersComponentsMap: FILTERS_MAP });

  return (
    <FiltersLayout
      filters={filters}
      searchButton={<SaveSearchButtonContainer />}
      applyButton={<ApplyFiltersButtonContainer />}
      tags={<TagsContainer />}
    />
  );
};
